<script lang="ts">
    import {_} from '../services/i18n';
    import StepValidationIcon from "./form/StepValidationIcon.svelte";

    export let title: string;
    export let isActive = false;
    export let valid:boolean;
    export let touched:boolean;
</script>


<div class="stepper-item  {isActive ? 'active' : ''}">
    <div class="stepper-item-inner">
        <div class="step-dot"></div>
        <div class="stepper-item-content">
            <div class="step-name">{title}</div>
            <div class="step-validation">
                <span><StepValidationIcon {valid} {touched}></StepValidationIcon></span>
            </div>
        </div>
    </div>
</div>

<style lang="scss">

  //@import 'src/stylesheets/variables.scss';

  .step-name{
    padding-left:1.5rem;
    font-weight: bold;
  }

  .step-validation{
    display: flex;
    width: 40px;
    align-content: center;
    flex-wrap: wrap;
    justify-content: center;
  }

</style>
